export enum CarRequestCarHistoryStatusEnum {
  RenovationWithSameCar = 1,
  Active = 2,
  Unlinked = 3,
  ChassisChange = 4
}